import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';

@observer
class ResizeDetectorChildWrapper extends Component {
    render() {
        return this.props.children;
    }
}

export default withTheme(ResizeDetectorChildWrapper) as any;



// WEBPACK FOOTER //
// ./src/Components/ResizeDetectorChildWrapper.tsx